<template>
  <div class="container container-global">
    <div class="title">
      <h2>Switch contraception</h2>
    </div>
    <div class="choice">
      <p>Moyen de contraception actuel :</p>
      <div class="select">
        <select
          name="slct"
          id="slct"
          v-model="contraception1"
          @change="resetResult()"
        >
          <option
            v-for="(contraception, i) in getContraception1"
            :key="i"
            :value="contraception"
          >
            {{ contraception }}
          </option>
        </select>
      </div>
      <p>Futur moyen de contraception :</p>
      <div class="select">
        <select
          name="slct"
          id="slct"
          v-model="contraception2"
          @change="resetResult()"
        >
          <option
            v-for="(contraception, i) in getFuturContraception"
            :key="i"
            :value="contraception"
          >
            {{ contraception }}
          </option>
        </select>
      </div>
    </div>
    <div class="buttons">
      <button @click="validate" class="validate">Valider</button>
      <div class="dbleButtons">
        <button class="annuler" @click="resetResult()">Annuler</button>
        <button class="quit" @click="goHome()">Quitter</button>
      </div>
    </div>
    <div v-if="getResult" class="results">
      <div class="title">
        <h3>Résultat</h3>
      </div>
      <p>{{ getResult }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SwitchComp",
  data() {
    return {
      contraception1: "Anneau vaginal",
      contraception2: "Anneau vaginal",
    };
  },
  methods: {
    ...mapActions("SwitchModule", [
      "sendSelectedContra1",
      "sendSelectedContra2",
      "analyzeQuestion",
      "resetResult",
    ]),
    validate() {
      this.sendSelectedContra1(this.contraception1);
      this.sendSelectedContra2(this.contraception2);
      this.analyzeQuestion();
    },
    goHome() {
      this.$router.push("/");
    },
  },
  computed: {
    ...mapGetters("SwitchModule", [
      "getContraception1",
      "getFuturContraception",
      "getResult",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";
.container {
  margin-top: 37px;
  .title {
    text-align: left;
  }
  .choice {
    p {
      color: $black-aigm;
      font-size: 18px;
      margin: 20px 0;
      font-weight: 500;
    }
    /* Reset Select */
    select {
      outline: 0;
      border: 0 !important;
      box-shadow: 0px 3px 6px #00000029;
      background-color: $light-pink;
    }
    /* Remove IE arrow */
    /* Custom Select */
    .select {
      display: flex;
      height: 3em;
      line-height: 3;
      background: $orange-aigm;
      overflow: hidden;
      border-radius: 0.25em;
    }
    select {
      flex: 1;
      padding: 0 0.5em;
      color: $orange-aigm;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
    }

    .container .select-selected:after {
      position: absolute;
      content: "";
      top: 14px;
      right: 10px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-color: #fff transparent transparent transparent;
    }
  }
  .buttons {
    text-align: center;
    .validate {
      @include buttonBig($orange-aigm, $white-aigm);
      margin: 30px auto 0 auto;
    }
    .dbleButtons {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 15px;
      .annuler {
        width: 40%;
        display: flex;
        justify-content: center;
        margin: 10px;
        @include button($light-pink, $dark-pink);
      }
      .quit {
        width: 40%;
        display: flex;
        justify-content: center;
        margin: 10px;
        @include button($red-button-aigm, $black-aigm);
      }
    }
  }
  .results {
    margin-top: 15px;
    background: $light-pink 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    padding: 15px;
    .title {
      h3 {
        letter-spacing: 1.09px;
        color: $orange-aigm;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
    p {
      color: $text-color-aigm;
      font-size: 17px;
    }
  }

  a.router-link-active {
    color: $black-aigm;
  }
}
</style>
